import { UrlService } from '../../../@core/services/urlService/url.service';
import { PreguntasFrecuentesData, PreguntasFrecuentes } from '../models/preguntas-frecuentes';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';

@Injectable()
export class PreguntasFrecuentesService extends PreguntasFrecuentesData {
  private apiRoute: string;

  constructor(private urlService: UrlService, private http: HttpClient) {
    super();
    this.apiRoute = `${this.urlService.getBaseUrl()}PreguntasFrecuentes/`;
  }

  create(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}CrearPreguntasFrecuentes`, formData);
  }

  update(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}EditarPreguntasFrecuentes`, formData);
  }

  getList(): Observable<PreguntasFrecuentes[]> {  
    return this.http.get<PreguntasFrecuentes[]>(`${this.apiRoute}GetPreguntasFrecuentes/`);
  }
  
  getById(id: number): Observable<PreguntasFrecuentes> {
    return this.http.get<PreguntasFrecuentes>(`${this.apiRoute}GetPreguntasFrecuentesById/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiRoute}EliminarPreguntasFrecuentes/${id}`, {});
  }

  getListByRol(id: number): Observable<PreguntasFrecuentes[]> {
    return this.http.get<PreguntasFrecuentes[]>(`${this.apiRoute}GetPreguntasFrecuentesByRol/${id}`);
  }
}
